import React from "react";
import { Reveal } from "../Reveal";
import PreviewForloeb from "./PreviewForloeb";
import faellesskab from "../../assets/faellesskab.webp";
import scene from "../../assets/scene.webp";
import udsigt from "../../assets/udsigt.webp";
import workshop from "../../assets/workshop.webp";

const categories = [
  {
    title: "Forstå dig selv",
    question: "Hvad former den måde, vi tænker, føler og handler på?",
    topics: ["Selvbevidsthed", "Tanker & følelser", "Overbevisninger", "Selvværd", "Autenticitet"],
    photo: udsigt,
  },
  {
    title: "Vær dig selv",
    question: "Hvad hjælper os med at leve i tråd med det, der er vigtigt – også når presset stiger?",
    topics: ["Værdier", "Retning", "Motivation", "Mod", "Mental styrke"],
    photo: scene,
    pos: "object-[center_22%]",
  },
  {
    title: "Vær med andre",
    question: "Hvad skaber stærke relationer og sunde fællesskaber?",
    topics: ["Kommunikation", "Feedback", "Konflikter", "Samarbejde", "Psykologisk tryghed"],
    photo: faellesskab,
  },
  {
    title: "Udtryk dig selv",
    question: "Hvordan viser vi os frem med autenticitet og gennemslagskraft?",
    topics: ["Kropssprog", "Stemme", "Aktiv lytning", "Præsentationsteknik", "Fremtoning"],
    photo: workshop,
  },
];

const formats = ["Oplæg", "Workshop", "Temadag", "Længere forløb"]; // eslint-disable-line no-unused-vars

const PreviewUndervisning = () => (
  <section id="undervisning" className="relative overflow-hidden" data-testid="preview-section-undervisning">
    <div className="relative bg-[#F4F1EC] pt-16 pb-16 sm:pt-24 sm:pb-24">
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <div className="mb-7 h-0.5 w-12 bg-[#852936]" />
        <h2
          className="font-display text-4xl font-semibold leading-[1.02] tracking-tight text-[#852936] sm:text-5xl md:text-6xl lg:text-7xl"
          data-testid="preview-heading-undervisning"
        >
          Undervisning &amp; Workshops
        </h2>
      </Reveal>

      <Reveal delay={80}>
        <h3 className="mt-10 font-display text-2xl font-semibold leading-snug text-[#111827] sm:mt-14 sm:text-3xl md:text-4xl" data-testid="preview-undervisning-temaer">
          Temaer
        </h3>
      </Reveal>

      {/* Four thematic cards – firkantede og samlet */}
      <div
        className="mt-8 grid gap-px overflow-hidden border border-black/[0.08] bg-black/[0.08] sm:grid-cols-2 lg:grid-cols-4"
        data-testid="preview-undervisning-temaer-grid"
      >
        {categories.map((cat, i) => (
          <div
            key={cat.title}
            className="flex h-full flex-col bg-white"
            data-testid={`preview-undervisning-card-${i}`}
          >
              <div className="relative aspect-[4/3] overflow-hidden">
                {cat.video ? (
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={cat.poster}
                    className="h-full w-full object-cover"
                    data-testid={`preview-undervisning-video-${i}`}
                  >
                    <source src={cat.video} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={cat.photo}
                    alt={cat.title}
                    className={`h-full w-full object-cover ${cat.pos || ""}`}
                  />
                )}
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="mt-4 font-display text-xl font-semibold leading-tight text-[#111827]">
                  {cat.title}
                </h3>
                <p className="mt-3 flex-1 text-[16px] leading-relaxed text-[#111827]/65">
                  {cat.question}
                </p>
                <span className="eyebrow mt-5 block text-[11px] font-semibold text-[#852936]">Emner</span>
                <div className="mt-2 flex flex-wrap gap-2">
                  {cat.topics.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-[#852936]/[0.08] px-3 py-1 text-[13px] font-semibold text-[#6E1F2B]"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
          </div>
        ))}
      </div>
    </div>
    </div>

      {/* Udvalgte workshops og forløb */}
    <div className="hero-nuance relative py-16 sm:py-24">
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <div>
        <Reveal>
          <h3 className="font-display text-2xl font-semibold leading-snug text-[#111827] sm:text-3xl md:text-4xl">
            Udvalgte workshops og forløb
          </h3>
          <p className="mt-6 max-w-3xl text-[16px] leading-relaxed text-[#111827]/70 sm:text-[17px]" data-testid="preview-forloeb-intro">
            Eksempler på workshops og udviklingsforløb – indhold, format og varighed tilpasses altid
            den konkrete målgruppe og situation.
          </p>
        </Reveal>
        <PreviewForloeb />
      </div>
    </div>
    </div>
  </section>
);

export default PreviewUndervisning;
